import { render, staticRenderFns } from "./uploadAttach.vue?vue&type=template&id=70ce7128&"
import script from "./uploadAttach.vue?vue&type=script&lang=js&"
export * from "./uploadAttach.vue?vue&type=script&lang=js&"
import style0 from "./uploadAttach.vue?vue&type=style&index=0&id=70ce7128&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports